<template>
  <div v-if="value">
    <div v-if="asMoment(value).isValid()">
      <multi-time-display :time="asMoment(value).format()"/>
    </div>
    <div v-else-if="getFormat(type) === 'temperature'">
      {{ formatTemperature(value) }} &deg; {{ customerContext.tempFormat() }}
    </div>
    <div v-else>{{ value }}</div>
  </div>
</template>

<script>

import Moment from 'moment-timezone'
import { get } from 'lodash'
import TemperatureConverterUtil from '@/util/TemperatureConverterUtil'
import MultiTimeDisplay from '@/components/shared/MultiTimeDisplay'

import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'

const TYPE_TEMPERATURE = 'temperature'

const mappedFormats = {
  'product_start_temp.start_temp': TYPE_TEMPERATURE,
  'route_product.start_temp': TYPE_TEMPERATURE,
  'product.start_temp': TYPE_TEMPERATURE,
  'product.min_start_temp': TYPE_TEMPERATURE,
  'product.max_start_temp': TYPE_TEMPERATURE,
  'product.max_temp': TYPE_TEMPERATURE,
  'product.min_temp': TYPE_TEMPERATURE
}

export default {
  name: 'AuditLogDetailsFormatter',
  components: {
    MultiTimeDisplay
  },
  mixins: [
    CurrentUserMixin
  ],
  props: {
    type: String,
    value: [
      Number,
      String,
      Array,
      Object
    ]
  },
  methods: {
    /**
     * Get the type of format used.
     */
    getFormat (type) {
      return get(mappedFormats, type)
    },
    /**
     * Formats the value as if it were a temperature.
     */
    formatTemperature (temperature) {
      return TemperatureConverterUtil.formatTemperature(
        TemperatureConverterUtil.to(temperature, 'C', this.customerContext.tempFormat())
      )
    },
    /**
     * Parses the given timestamp. If it does not match one of the following
     * formats then the returned moment object is invlaid. Valid formats:
     *  YYYY-MM-DD H:m:s
     *  YYYY-MM-DDTH:m:sZ
     *
     * Audit log datetime values are stored/serialized in UTC, so we parse them
     * strictly as UTC. This yields a correct instant that MultiTimeDisplay can
     * convert to the customer's configured timezone (matching the rest of the
     * audit log).
     *
     * @return Moment
     */
    asMoment (timestamp) {
      const validFormats = [
        'YYYY-MM-DD H:m:s',
        'YYYY-MM-DDTH:m:sZ'
      ]

      return Moment.utc(timestamp, validFormats, true)
    }
  }
}
</script>

<style scoped>

</style>
